<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i class="el-icon-menu"></i>
        </div>
        <div class="logo">
            <!-- <div style="float: left">&nbsp;simple</div> -->
        </div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 全屏显示 -->
                <span style="font-size: 15px;font-family: Microsoft Yahei"> 尊敬的<strong style="font-size: 16px">{{name}}</strong>，欢迎您</span>
                <a-dropdown>
                   <a-icon type="caret-down" />
                    <a-menu slot="overlay">
                    <a-menu-item @click="loginout">
                        <a href="javascript:;">退出登录</a>
                    </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import bus from '../components/bus';
    export default {
        data() {
            return {
                collapse: false,
                fullscreen: false,
                typer:'',
                truename:'',
                message: 2,
                role:'',
                dialogVisible:false,
                dialogVisible1:false,
                modPass:{
                    newPwd:"",
                    oldPwd:""
                },
                modName:{
                    name:""
                },
                
            }
        },
        created(){
         
        },
        computed:{
            ...mapState(["name"]),
            // username(){
            //     let username = sessionStorage.getItem('username');
            //     return username ? username : this.name;
            // }
        },
        methods:{
            // 用户名下拉菜单选择事件
            

            loginout(){
                        sessionStorage.clear();
                    this.$router.push('/login');
            },
            // 侧边栏折叠
            collapseChage(){
                this.collapse = !this.collapse;
                bus.$emit('collapse', this.collapse);
            },
            // 全屏事件
            handleFullScreen(){
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
        },
        mounted(){
            // this.truename=JSON.parse(sessionStorage.userMess).name;
            // this.typer = JSON.parse(sessionStorage.userMess).type;
            // this.headimg = JSON.parse(sessionStorage.userMess).headimg;
            if(document.body.clientWidth < 900){
                this.collapseChage();
            }
        }
    }
</script>
<style scoped>
    .header {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 70px;
        font-size: 22px;
        color: #fff;
        background:#001529 ;
        /*#2A513E*/
    }
    .collapse-btn{
        float: left;
        padding: 0 21px;
        cursor: pointer;
        line-height: 70px;
    }
    .header .logo{
        float: left;
        width:500px;
        line-height: 70px;
    }
    .header-right{
        float: right;
        padding-right: 50px;
    }
    .header-user-con{
        display: flex;
        height: 70px;
        align-items: center;
    }
    .btn-fullscreen{
        transform: rotate(45deg);
        margin-right: 5px;
        font-size: 24px;
    }
    .btn-bell, .btn-fullscreen{
        position: relative;
        width: 60px;
        height: 30px;
        text-align: center;
        border-radius: 15px;
        cursor: pointer;
    }
    .btn-bell-badge{
        position: absolute;
        right: 0;
        top: -2px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        background: #f56c6c;
        color: #fff;
    }
    .btn-bell .el-icon-bell{
        color: #fff;
    }
    .user-name{
        margin-left: 10px;
    }
    .user-avator{
        margin-left: 20px;
    }
    .user-avator img{
        display: block;
        width:40px;
        height:40px;
        border-radius: 50%;
    }
    .el-dropdown-link{
        color: #fff;
        cursor: pointer;
    }
    .el-dropdown-menu__item{
        text-align: center;
    }
</style>
